import { COMPANY } from "@/lib/company";

const SITE_BASE_URL =
    (typeof process !== "undefined" && process.env.REACT_APP_SITE_BASE_URL) ||
    "https://elevatebuildconstruction.co.uk";

function absUrl(path = "") {
    const p = path.startsWith("/") ? path : `/${path}`;
    return `${SITE_BASE_URL}${p}`;
}

export const ORG_ID = `${SITE_BASE_URL}/#organization`;
export const WEBSITE_ID = `${SITE_BASE_URL}/#website`;

/** Reusable schema.org address block sourced from COMPANY.address. */
export function postalAddress() {
    return {
        "@type": "PostalAddress",
        streetAddress: COMPANY.address.streetAddress,
        addressLocality: COMPANY.address.city,
        addressRegion: COMPANY.address.region,
        postalCode: COMPANY.address.postcode,
        addressCountry: COMPANY.address.country,
    };
}

/** Organization + LocalBusiness/GeneralContractor combined into one node. */
export function organizationSchema() {
    return {
        "@context": "https://schema.org",
        "@type": ["Organization", "GeneralContractor", "LocalBusiness"],
        "@id": ORG_ID,
        name: "EB Construction",
        legalName: COMPANY.legalName || "EB Construction Ltd",
        url: SITE_BASE_URL,
        logo: `${SITE_BASE_URL}/brand/logo-primary.png?v=3`,
        image: `${SITE_BASE_URL}/brand/logo-primary.png?v=3`,
        slogan: "Built on Trust. Designed for Life.",
        description:
            "Manchester-based UK construction firm delivering residential, commercial, industrial and civil projects across the North West. UK Home Office licensed sponsor.",
        foundingDate: "2023-10-23",
        telephone: COMPANY.phoneE164,
        email: COMPANY.email,
        priceRange: "££",
        address: postalAddress(),
        geo: {
            "@type": "GeoCoordinates",
            latitude: 53.4807,
            longitude: -2.2426,
        },
        openingHoursSpecification: [
            {
                "@type": "OpeningHoursSpecification",
                dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
                opens: "08:00",
                closes: "18:00",
            },
        ],
        areaServed: [
            { "@type": "AdministrativeArea", name: "Greater Manchester" },
            { "@type": "AdministrativeArea", name: "North West England" },
        ],
        sameAs: [
            "https://www.linkedin.com/company/eb-construction-ltd",
            "https://www.instagram.com/ebconstructionltd",
            "https://www.facebook.com/ebconstructionltd",
        ],
    };
}

/** WebSite schema with an internal SearchAction hint. */
export function websiteSchema() {
    return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "@id": WEBSITE_ID,
        url: SITE_BASE_URL,
        name: "EB Construction",
        publisher: { "@id": ORG_ID },
        potentialAction: {
            "@type": "SearchAction",
            target: `${SITE_BASE_URL}/projects?category={search_term_string}`,
            "query-input": "required name=search_term_string",
        },
    };
}

/** Small helper to build an ImageObject from a project cover_image path. */
export function projectImage(project) {
    const src = project?.cover_image || project?.image;
    if (!src) return null;
    if (src.startsWith("http")) return src;
    if (src.startsWith("/api/")) return absUrl(src);
    return absUrl(src);
}

/** Absolute canonical URL helper. */
export function absoluteUrl(path) {
    return absUrl(path);
}

export { SITE_BASE_URL };
